module.exports = __webpack_public_path__ + "img/avatar4.d970b46d.png";